Promise = require 'bluebird'
Recents = require 'app/scripts/lib/recents'
$ = require 'jquery'
moment = require 'moment'
{ trackUe } = require '@trello/analytics'
ninvoke = require 'app/scripts/lib/util/ninvoke'
f = require 'effing'
ApiError = require 'app/scripts/network/api-error'
Auth = require 'app/scripts/db/auth'
TrelloPerf = require('app/common/debug/perf').default
{ flushPerformanceMetrics } = require 'app/common/debug/flushPerformanceMetrics'
{ verticals } = require 'app/scripts/views/onboarding/constants'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ ROUTES } = require '@trello/routes'
{ navigate } = require 'app/scripts/controller/navigate'

# If you call someMoment.year(undefined), that's a no-op.
# If you call someMoment.year(NaN), that gives you an invalid date.
parseMaybe = (str) ->
  result = parseInt(str, 10)
  if isNaN(result)
    undefined
  else
    result

mapMaybe = (f, maybeNum) ->
  if maybeNum?
    f(maybeNum)
  else
    undefined

module.exports =
  routes: [
    # Old style URL
    [ROUTES.BOARD_OLD.route, 'oldBoardView']
    # New style URL
    [ROUTES.BOARD_REFERRAL.route, 'boardReferralView']
    [ROUTES.BOARD.route, 'boardView']
    # Old style URLs
    [ROUTES.CARD_AND_BOARD_OLD.route, 'oldCardView']
    [ROUTES.CARD_OLD.route, 'oldCardView']
    # New style URL
    [ROUTES.CARD.route, 'cardView']
    # new user board creation
    [ROUTES.WELCOME.route, 'onboardingView']
    [ROUTES.CREATE_FIRST_BOARD.route, 'createFirstBoardView']
  ]

  boardReferralView: (shortLink, name, referrerUsername) ->
    @boardView(shortLink, '', referrerUsername)

  boardView: (shortLink, path, referrerUsername) ->
    # :slug
    # :slug/:section
    # :slug/:section/:subsection
    # :slug/map
    # :slug/member/:username
    # :slug/calendar/:year/:month
    # :slug/calendar/:year/:month/:day
    # :slug/power-ups/enabled
    # :slug/power-ups/category/:category
    # :slug/power-up/:powerup
    # :slug/power-up/:powerup/enable
    # :slug/butler
    path ?= ""
    [slug, section, subsection, monthOrCategory, day] = path.split('?')[0].split '/'

    settings = { idBoard: shortLink, referrerUsername: referrerUsername }

    if section == 'calendar'
      calendarMoment = moment().startOf('day')
      calendarMoment.year parseMaybe(subsection)
      calendarMoment.month mapMaybe(f.sub(1), parseMaybe(monthOrCategory))
      calendarMoment.date parseMaybe(day)
      if calendarMoment.isValid()
        settings.calendarDate = calendarMoment.toDate()

    if section == 'member' && subsection?
      settings.usernameBoardProfile = subsection

    if section == 'power-ups' && subsection?
      settings.directorySection = subsection
      if monthOrCategory?
        settings.directoryCategory = monthOrCategory

    if section == 'power-up' && subsection?
      settings.directoryIdPowerUp = subsection

      if monthOrCategory? && monthOrCategory == 'enable'
        settings.directoryIsEnabling = true

    if section in ['calendar', 'member', 'power-up', 'power-ups', 'map', 'butler']
      settings.section = section

    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
    @displayBoard(settings)
      .tap ->
        TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
        TrelloPerf.reportStartupMetrics()
        flushPerformanceMetrics
          buffered: TrelloPerf.getCachedMetrics()
          flush: -> TrelloPerf.clearCachedMetrics()
      .done()

  oldBoardView: (path) ->
    # :id
    # :slug/:id
    # :slug/:id/:section
    # :slug/:id/member/:username

    settings = {}

    parts = path.split('/')
    if parts.length == 1
      settings.idBoard = parts[0]
    else
      settings.idBoard = parts[1]

    if parts.length == 3
      settings.section = parts[2]

    else if parts.length == 4
      settings.usernameBoardProfile = parts[3]

    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
    @displayBoard(settings)
      .tap ->
        TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_BOARD_VIEW)
        TrelloPerf.reportStartupMetrics()
        flushPerformanceMetrics
          buffered: TrelloPerf.getCachedMetrics()
          flush: -> TrelloPerf.clearCachedMetrics()
      .done()

  cardView: (shortLink, path) ->
    highlight =
      if location.hash.length > 1
        # Remove leading #
        location.hash.substr(1)
      else
        null
    replyToComment = @getQueryParamByKey('replyToComment')
    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
    @displayBoard(idCard: shortLink, highlight: highlight, replyToComment: replyToComment)
      .tap ->
        TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
        TrelloPerf.reportStartupMetrics()
        flushPerformanceMetrics
          buffered: TrelloPerf.getCachedMetrics()
          flush: -> TrelloPerf.clearCachedMetrics()
      .done()

  oldCardView: (slug, idBoard, cardComponent) ->
    # cardComponent can be one of several things.
    #
    # It could be an id, or it could be a shortLink, which are both fine.
    # *Or* it could be an idShort, if it's a #123-style link in an old
    # notification.
    #
    # We don't want displayBoard to have to special-case this one annoying
    # scenario (it's the only case where you need to use the idBoard in order
    # to determine the idCard), so we normalize the route here to maintain
    # backwards compatibility.

    isIdShort = (str) -> /^\d+$/.test(str)

    idCardPromise = if isIdShort(cardComponent)
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelLoader = require 'app/scripts/db/model-loader'
      ModelLoader.for 'top-level', 'loadCardId', idBoard, cardComponent
      .catch ApiError, -> null
    else
      Promise.resolve(cardComponent)

    TrelloPerf.startMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
    idCardPromise.then (idCard) =>
      @displayBoard({ idBoard, idCard })
        .tap ->
          TrelloPerf.stopMeasurement(TrelloPerf.Keys.BOOTSTRAP_CARD_VIEW)
          TrelloPerf.reportStartupMetrics()
          flushPerformanceMetrics
            buffered: TrelloPerf.getCachedMetrics()
            flush: -> TrelloPerf.clearCachedMetrics()
      .done()

  showCardDetail: (card, { highlight, runMethod, isNavigating, replyToComment, method } = {}) ->
    if !card?
      return

    if !@onBoardView(card.getBoard()?.id) ||
       (card.modelCache != @getCurrentModelCache())
      navigate @getCardUrl(card, highlight, replyToComment), { trigger: true }
      return

    # track entrances from both card front and external sources
    method ?= ''
    trackUe('card details', 'opens', 'card details view', '', '', method, {
      loggedIn: Auth.isLoggedIn(),
      visibility: card.getBoard().getPref('permissionLevel'),
      cardId: card.id,
      boardId: card.getBoard().id
    })

    # Dependency required at call site to avoid import cycles, do not lift to top of module
    CardDetailView = require 'app/scripts/views/card/card-detail-view'
    cardDetailView = new CardDetailView(modelCache: @getCurrentModelCache(), model: card)

    # Figure out if we're showing the calendar before we open the dialog;
    # it's possible that the card will get moved to another board
    # while the dialog is open
    board = card.getBoard()
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    BoardView = require 'app/scripts/views/board/board-view'
    existingBoardView = card.getBoard() && @applicationView.existingSubviewOrUndefined(BoardView, card.getBoard())
    showingCalendar = @showingCalendar(existingBoardView)
    showingMap = @showingMap(existingBoardView)

    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Dialog = require 'app/scripts/views/lib/dialog'

    section = ''
    section = 'calendar' if showingCalendar

    if showingMap
      section = 'map'

      # If the user is opening a card back from within the map,
      # we should return them to board instead of the card where the opened map.
      existingBoardView.mapReturnCard = null

    Dialog.show
      view: cardDetailView
      hide: (isNavigating) =>
        # Dependency required at call site to avoid import cycles, do not lift to top of module
        AttachmentViewer = require 'app/scripts/views/internal/attachment-viewer'
        AttachmentViewer.clear()
        if !isNavigating
          # This is bad. Here we're guessing the right URL for return.
          # It's necessary because the user can mess around with the back and
          # forward buttons to get this dialog to pop by URL.
          @setBoardLocation(
            board.id,
            section
          )

          @title board.get('name')
        onBoardViewFlag = featureFlagClient.get('ecosystem.auto-enable-calendar-popover', 'none') == 'onBoardView'
        if board.shouldRenderAutoEnableCalendarPopover() && onBoardViewFlag
          existingBoardView.renderAutoEnableCalendarPopover()

      isNavigating: isNavigating

    @waitForId card, =>
      navigate @getCardUrl(card, highlight, replyToComment),
        replace: @onCardView()
        trigger: false
      Recents.add('card', card.id)

    if runMethod?
      cardDetailView[runMethod]()

    if highlight?
      cardDetailView.highlight(highlight, true)

    if replyToComment?
      cardDetailView.replyToComment(replyToComment)

    return

  createFirstBoardView: ->
    Promise.using @getSpinner(), =>
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelLoader = require 'app/scripts/db/model-loader'
      return ModelLoader.await('boardsData').then =>
        me = Auth.me()
        if !me.isLoggedIn()
          return window.location = '/login'

        if featureFlagClient.get('activation.onboarding_v2', false)
          urlParams = new URLSearchParams(window.location.search)
          selectedVertical = urlParams.get('selectedVertical')

          if !verticals[selectedVertical] && selectedVertical != 'default'
            return navigate 'welcome', { trigger: true }
        # Only run this if flag is disabled, where we redirect if they already have boards
        else
          memberHasBoards = me.boardList.length > 0
          if memberHasBoards || me.isDismissed('create-first-board')
            return navigate '/', { trigger: true }

        @clearPreviousView()
        @setViewType('create-first-board')
        @title('Create Your Board')
        # Dependency required at call site to avoid import cycles, do not lift to top of module
        CreateFirstBoardView = require 'app/scripts/views/onboarding/create-first-board-view'
        view = @topLevelView(CreateFirstBoardView, me)
        $('#trello-root').addClass('body-hide-header')
        $('#content').html(view.render().el)
    .done()

  onboardingView: ->
    Promise.using @getSpinner(), =>
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      ModelLoader = require 'app/scripts/db/model-loader'
      return ModelLoader.await('boardsData').then =>
        me = Auth.me()
        if !me.isLoggedIn()
          return window.location = '/login'

        if !featureFlagClient.get('activation.onboarding_v2', false)
          return navigate '/', { trigger: true }

        @clearPreviousView()
        @setViewType('onboarding-welcome')
        @title('Welcome To Trello')
        # Dependency required at call site to avoid import cycles, do not lift to top of module
        WelcomeView = require 'app/scripts/views/onboarding/welcome-view'
        view = @topLevelView(WelcomeView, me)
        $('#trello-root').addClass('body-hide-header')
        $('#content').html(view.render().el)
    .done()
